const WestminsterWaltzFollow = {
    name: "Westminster Waltz",
    bpm: 162,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default WestminsterWaltzFollow;